import { IconMeatball } from '@consta/icons/IconMeatball'
import { Button } from '@consta/uikit/Button'
import { ContextMenu } from '@consta/uikit/ContextMenu'
import { withTooltip } from '@consta/uikit/withTooltip'
import type { ContextMenuItem } from '@core/core/types'
import { IconPanelAdd } from '@core/icons'
import { getSimpleTooltipContent } from '@library/utils'
import type { FC } from 'react'
import { useRef, useState } from 'react'

import css from './TabsMenu.css'

type TabsMenuProps = {
  isSplitDisabled: boolean
  onSplitView: () => void
  onCloseWorkArea: () => void
}

const SplitViewButton = withTooltip({
  tooltipContent: getSimpleTooltipContent('Разделить рабочую область'),
  mode: 'mouseover',
  direction: 'downLeft',
})(Button)

export const TabsMenu: FC<TabsMenuProps> = ({ isSplitDisabled, onSplitView, onCloseWorkArea }) => {
  const menuAnchorRef = useRef(null)
  const [showMenu, setShowMenu] = useState<boolean>(false)
  const onToggleMenu = () => {
    setShowMenu(prev => !prev)
  }
  const hideMenu = () => {
    setShowMenu(false)
  }

  const handleCloseAll = () => {
    onCloseWorkArea()
    hideMenu()
  }

  const handleSplitView = () => {
    onSplitView()
    hideMenu()
  }

  const menuItems: ContextMenuItem[] = [{ label: 'Закрыть все', action: handleCloseAll }]

  return (
    <div className={css.container}>
      <SplitViewButton
        size="xs"
        view="clear"
        iconSize="s"
        iconLeft={IconPanelAdd}
        disabled={isSplitDisabled}
        onClick={handleSplitView}
      />
      <Button
        ref={menuAnchorRef}
        size="xs"
        view="clear"
        iconLeft={IconMeatball}
        onClick={onToggleMenu}
      />
      <ContextMenu
        isOpen={showMenu}
        anchorRef={menuAnchorRef}
        size="s"
        direction="downStartLeft"
        items={menuItems}
        getItemLabel={item => item.label}
        getItemOnClick={item => item.action}
        getItemDisabled={item => item.disabled}
        onClickOutside={hideMenu}
      />
    </div>
  )
}
